import React, { useState, useRef, useEffect } from 'react';
import '../App.css'; // Estilos CSS para el chat
import '../AppRespopnsive.css';
import { 
    FaArrowDown, 
    FaDownload, 
    FaSignInAlt, 
    FaSignOutAlt} from 'react-icons/fa'; // Importa los iconos necesarios
import { useAuth0 } from "@auth0/auth0-react";
import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import Terminos from './terminosDeUso';
import Suscripciones from './suscripciones';
import './Modal.css';
import FilteredPosts from './historialRecto'; //// historial
import { useNavigate, useLocation } from "react-router-dom";
import { useParams } from 'react-router-dom';
import client from '../apolloClient';
import { generatePdf } from './modulos-propios/generatePDF';
import { StreamingText } from './modulos-propios/streamingText';
import useAutoScroll from './modulos-propios/useSingleAutoScroll'; // Importa el módulo useAutoScroll
import useScrollToBottom from './modulos-propios/useSingleScrolledToBottom'; // Importa el módulo useScrollToBottom
import useClickOutside from './modulos-propios/useClickOutside'; // Importa el módulo useClickOutside
import ButtonGroup from './icons/buttonGroup_sinDash';
import ToolTipBarra from './icons/TooltipBarra';
import UserChat from './userChat/selectUserChat';
import InputComponent from './inputSinfoco/InputComponent_sugerencias_3';
import FasePensamiento from './Spinner-chat/FasePensamiento';


const useradmin = [
  process.env.REACT_APP_ADMIN,
  process.env.REACT_APP_ADMIN2,
  process.env.REACT_APP_ADMIN3,
  process.env.REACT_APP_ADMIN4,
  process.env.REACT_APP_ADMIN5,
  process.env.REACT_APP_ADMIN6
];

const isAdmin = (currentUser) => {
  return useradmin.includes(currentUser);
};

const useWindowWidth = () => {
  const [width, setWidth] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 1024
  );

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return width;
};

const FETCH_USERCONDUCTUAL_QUERY = gql`
  query($username: String!) {
    getUserconductual(username: $username) {
      id
      username
      disc
      eneagrama
      bigfive
    }
  }
`;

const FETCH_USERCONDUCTUAL_LINK_QUERY = gql`
  query($username: String!) {
    getUsersLinkByUsername(username: $username) {
      id
      nombres
      dob
      email
      disc
      createdAt
    }
  }
`;

const FETCH_POST_QUERY = gql`
  query($postId: ID!) {
    getPost(postId: $postId) {
      id
      body
      estado
      createdAt
      username
      likeCount
      likes {
        username
      }
      commentCount
      comments {
        id
        body
        respuesta
        createdAt
        username
      }
    }
  }
`;

const SUBMIT_COMMENT_MUTATION = gql`
  mutation($postId: String!, $body: String!,$username: String!, $idUserlink: String!, $modelo: String!) {
    createComment(postId: $postId, body: $body, username: $username, idUserlink: $idUserlink, modelo: $modelo) {
      id
      comments {
        id
        body
        respuesta
        createdAt
        username
      }
      commentCount
    }
  } 
`;

const CREATE_POST_MUTATION = gql`
  mutation createPost($body: String!, $username: String!, $idUserlink: String!) {
    createPost(body: $body, username: $username, idUserlink: $idUserlink) {
      id
      body
      estado
      createdAt
      username
      likes {
        id
        username
        createdAt
      }
      likeCount
      comments {
        id
        body
        respuesta
        username
        createdAt
      }
      commentCount
    }
  }
`;



const Chat = () => {
  const { postId } = useParams();
  const [showSidebar, setShowSidebar] = useState(true); // Estado para controlar la visibilidad del sidebar
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [showDropdown, setShowDropdown] = useState(false);
  useClickOutside(showDropdown, setShowDropdown); // Utiliza el módulo useClickOutside
  const [currentChat, setCurrentChat] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSuscripcionesOpen, setSuscripcionesOpen] = useState(false);
  const [messageInput, setMessageInput] = useState('');
  const [isStreaming, setIsStreaming] = useState(false);
  const [selectedUser, setSelectedUser] = useState('Selecionar usuario');
  const [idUserlink, setSidUserlink] = useState('');
  const messagesEndRef = useRef(null);
  const bodymessagesEndRef = useRef(null);
  const isScrolledToBottom = useScrollToBottom(bodymessagesEndRef); // Utiliza el módulo useScrollToBottom
  const { user, isAuthenticated, isLoading } = useAuth0();
  const { loginWithRedirect, logout } = useAuth0();
  const navigate = useNavigate();
  const username = user?.sub?.replace(/[^a-zA-Z0-9]/g, '');
  const lastMessageRef = useRef(null);

   // Cuando currentChat cambia, desplazamos el último mensaje al centro
   useEffect(() => {
    if (lastMessageRef.current) {
      lastMessageRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest'
      });
    }
  }, [currentChat]);

  const location = useLocation();
const model = location.state?.selectedModel || 'Conductual básico';
const [selectedModel, setSelectedModel] = useState(model);

function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= breakpoint);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= breakpoint);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint]);

  return isMobile;
}

const isMobile = useIsMobile(); // Esto te dice si estás en modo responsive

  const windowWidth = useWindowWidth();

// Compensación para mover el botón junto con el sidebar en responsive
const responsiveLeft = windowWidth <= 768
  ? sidebarOpen ? '20px' : '200px'  // ancho exacto del sidebar
  : sidebarOpen ? '220px' : '20px';
  const { data: userConductualLinkData, loading: userConductualLinkLoading, error: userConductualLinkError, refetch: refetch } = useQuery(FETCH_USERCONDUCTUAL_LINK_QUERY, {
    variables: { username },
    skip: !isAuthenticated
  });

  const destinatario = location.state?.selectedUser.nombres || '';
  
  const postIdOrigin = location.state?.selectedPostId || '';

  useEffect(() => {
    if (location.state?.refetchNeeded) {
      refetch();
    }
  }, [location.state, refetch]);


  const { data: userConductualData, loading: userConductualLoading, error: userConductualError, refetch: refetchUser } = useQuery(FETCH_USERCONDUCTUAL_QUERY, {
    variables: { username , idUserlink},
    skip: !isAuthenticated
  });


  const userConductual = userConductualData?.getUserconductual;


  useEffect(() => {
    if (isAuthenticated) {
      refetch();
    }
  }, [isAuthenticated, refetch]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setShowSidebar(false);
      }
    };

    handleResize(); // Verificar tamaño al cargar la página
    window.addEventListener('resize', handleResize); // Verificar tamaño al cambiar el tamaño de la pantalla
    return () => window.removeEventListener('resize', handleResize); // Limpiar el event listener
  }, []);

  const manualScrollToBottom = () => {
    if (messagesEndRef.current && typeof messagesEndRef.current.scrollIntoView === 'function') {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth", block: "end", inline: "end" });
    }
  };

  useAutoScroll(messagesEndRef, currentChat);

  useEffect(() => {
    const handleResize = () => {
      manualScrollToBottom();
    };

    const resizeObserver = new ResizeObserver(() => {
      handleResize();
    });

    const observer = new MutationObserver(() => {
      manualScrollToBottom();
    });
    const config = { childList: true, subtree: true };

    if (messagesEndRef.current && messagesEndRef.current.parentNode) {
      resizeObserver.observe(messagesEndRef.current.parentNode);
      observer.observe(messagesEndRef.current.parentNode, config);
    }

    return () => {
      if (messagesEndRef.current && messagesEndRef.current.parentNode) {
        resizeObserver.disconnect();
        observer.disconnect();
      }
    };
  }, [currentChat]);

  useEffect(() => {
    // Scroll to bottom when currentChat changes
    manualScrollToBottom();
  }, [currentChat]);

  const handleDropdownToggle = () => {
    setShowDropdown(!showDropdown);
  };

  const createPostMutation = () => {
    return client.mutate({
      mutation: CREATE_POST_MUTATION,
      variables: { body: 'Nuevo chat', username:user.sub, idUserlink: idUserlink},
      onCompleted: (data) => {
        console.log('Mutación completada: ', data);
      },
      onError: (error) => {
        console.error('Error en la mutación: ', error);
      }
    });
  }


  
  const callCreatePost = async (refetch) => {
    try {
      const response = await createPostMutation();
      console.log("Llamada a createPostMutation exitosa:", response.data.createPost.id);
      const postId = response.data.createPost.id;
      //await refetch(); // Refetch posts to update the list
      // Redirige a la nueva ruta
      navigate(`/chat/${postId}`);
    } catch (error) {
      console.error("Error al llamar a createPostMutation:", error);
    }
  }

  const handleNewChat = () => {
    callCreatePost();
  };

  const [showInfo, setShowInfo] = useState(false);
  const [showCopyIcon, setShowCopyIcon] = useState(true);

  const handleCopy = () => {
    const chatText = currentChat.map(message => `${message.sender}: ${message.text}`).join('\n');
    navigator.clipboard.writeText(chatText);
    setShowInfo(true);
    setShowCopyIcon(false);
    setTimeout(() => {
      setShowInfo(false);
      setShowCopyIcon(true);
    }, 1500); // Ocultar el mensaje después de 1.5 segundos y volver a mostrar el icono de copia
  };

  const handleRegenerate = () => {
    // Lógica para regenerar la respuesta del chatbot
  };

  const toggleSidebar = () => {
    setShowSidebar(!showSidebar); // Cambia el estado de visibilidad del sidebar
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault(); // Previene el salto de línea
      sendMessage(e);     // Envía el mensaje
    }
    // Si es Shift + Enter, no se hace nada: se permite salto de línea
  };

  const { loading, error, data } = useQuery(FETCH_POST_QUERY, {
    variables: { postId },
    skip: postId ? false : true, // Skip si postId es undefined al montar el componente
  });

  useEffect(() => {
    if (data && data.getPost) {
      const post = data.getPost;
      if (post && Array.isArray(post.comments)) {
        const messages = post.comments.flatMap(comment => [
          { text: comment.body, sender: 'user', createdAt: comment.createdAt },
          comment.respuesta && { text: comment.respuesta, sender: 'bot', createdAt: comment.createdAt }
        ]).filter(Boolean);
        const messagesToShow = messages.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
        setCurrentChat(messagesToShow);
      }
    }
  }, [data]);

  if (error) return <p>Procesando</p>;



  const sendMessage = () => {
    
    if (messageInput.trim() !== '') {
      setIsStreaming(true);
     const newMessage = {
      text: (
        <div>
          <div>{messageInput}</div>
          <div style={{ paddingTop: '28px' }}>
          <FasePensamiento />
          </div>
        </div>
      ),
      sender: 'user'
    };
      setCurrentChat([...currentChat, newMessage]);

      client.mutate({
        mutation: SUBMIT_COMMENT_MUTATION,
        variables: { postId: postId, body: messageInput, username: username, idUserlink: idUserlink, modelo: selectedModel},
        onError: (error) => {
          console.error('Error al enviar el comentario:', error);
        }
      });
      setMessageInput(''); // Limpiar el input después de enviar el mensaje
      
    }

  };

   


    const sendMessage2 = () => {
      if (!messageInput.trim()) return;
      setIsStreaming(true);
  
      const newMessage = {
        text: (
          <div>
            <div>{messageInput}</div>
            <div style={{ paddingTop: '28px' }}>
              <FasePensamiento />
            </div>
          </div>
        ),
        sender: 'user'
      };
  
      // Añadimos el nuevo mensaje
      setCurrentChat(prev => [...prev, newMessage]);
  
      // Enviamos la mutación
      client.mutate({
        mutation: SUBMIT_COMMENT_MUTATION,
        variables: {
          postId,
          body: messageInput,
          username,
          idUserlink,
          modelo: selectedModel
        },
        onError: error => {
          console.error('Error al enviar el comentario:', error);
        }
      });
  
      setMessageInput('');
      
    };
  
  


const sampleDataOwner = {
  getUserconductual: userConductual,
};

const userConductualLINK = userConductualLinkData?.getUsersLinkByUsername || [];

const idUserlinkquery = String(userConductual?.id ?? '');


const michat = {
__typename: 'UserConductualLink',
id: idUserlinkquery,
nombres: 'Yo mism@',
createdAt: "2024-11-28T00:08:11.021Z",
};


const sampleData = {
getUsersLinkByUsername: [...userConductualLINK],
};

  const handleNameSelect = (item) => {
    setSelectedUser(item);
    setSidUserlink(selectedUser.id);
    //refetch()
  };

  

  const handleChatNavigation = () => {
    localStorage.clear()
    navigate(`/new/chat`); // Navega a la página del chat
  };

  const handleSupervisar = () => {
    localStorage.clear()
    navigate(`/miequipo`)
  };

  return (
    <div className="chat-container">
       
      {/* Mensajes chat */}
      {loading ? (
        <div className="spinner-container">
          <div className="spinner">
            <img src='/images/logo512.png' alt="loading" />
          </div>
        </div>
      ) : (
        isAuthenticated && (
          <div className={`main2 ${!sidebarOpen && 'expanded'}`}>
            <div className="messages" ref={bodymessagesEndRef} style={{ overflowY: 'auto', height: '100vh' }}>
              {currentChat.map((message, index) => (
                <div
                key={index}
                className={`message ${message.sender}`}
                ref={messagesEndRef}
                style={{
                  marginBottom: message.text?.props?.children?.[1]?.props?.children === 'Pensando...' ? '50px' : '50px'
                }}
              >
                  {message.sender === 'bot' ? (
                    <>
                      <StreamingText text={message.text} setIsStreaming={setIsStreaming} isStreaming={isStreaming} />
                    </>
                  ) : (
                    <>
                      <img src={user.picture} alt={user.name} className='chat-img-user' />
                      <span>{message.text}</span>
                    
                    </>
                  )}
                  {message.sender === 'bot' && (
                    <div className="message-options">
                      <button className='respuesta-options-button' onClick={() => generatePdf(message.text)}><FaDownload /></button>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )
      )}
      {/* BARRA PARTE SUPERIOR */}
      <div className="floating-menu">
      {userConductual !== null &&( <UserChat data={sampleData} onNameSelect={handleNameSelect}  initialSearchTerm={destinatario} sidebarOpen={sidebarOpen} />)}
        {/* LOGO --- ISOLOGO */}
        {isAuthenticated && selectedUser !== 'Selecionar usuario' && ( <img src='/images/LOGO-conductualGPT-01.svg' className={`floating-menu-logo-2 ${(!sidebarOpen && !isMobile) ? 'collapsed' : ''}`} /> )}
        {/* CONTENIDO LOGIN--LOGOUT Y Menu */}
        <div className="sidebar-buttons">
          {!isAuthenticated && (
            <button onClick={() => loginWithRedirect()}>
              <FaSignInAlt />
              <span>Ingresar</span>
            </button>
          )}
        </div>
        {isAuthenticated && (
          <div className="profile-container">
           
            <div id="dropdown" className="dropdown">
            <img src={user.picture} alt={user.name} onClick={handleDropdownToggle}/>
              {showDropdown && (
                <div className="dropdown-menu">
                     <button>
                        <a className='button-link' href="#" onClick={handleChatNavigation}>Inicio</a>
                     </button>
                  
                     

                     <button><a className='button-link' href="#" onClick={() => navigate(`/equipos`)}>Crear equipo</a></button>
                      {isAdmin(user.sub) && (<button className='button-link' onClick={() => navigate(`/trained`, { state: { selectedUser } })}>Entrenar</button>)}
                      {isAdmin(user.sub) && ( <button><a className='button-link' href="#" onClick={handleSupervisar}>Supervisar</a></button>)}
                 
                 <button >
                 <a className='button-link' href="#" onClick={(e) => { e.preventDefault();localStorage.clear();logout({ logoutParams: { returnTo: window.location.origin } });}}>Salir</a>
                      <FaSignOutAlt className="icon-spacing"/>
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      {/* Sidebar */}
      {isAuthenticated && selectedUser !== 'Selecionar usuario' && (
<div>
 <ToolTipBarra sidebarOpen={sidebarOpen} content={sidebarOpen ? 'Cerrar barra lateral' : 'Abrir barra lateral'}>
 

<div 
  className={`sidebar-toggle ${!sidebarOpen && 'collapsed'}`}
  onClick={() => setSidebarOpen(!sidebarOpen)}
  style={{
    position: 'fixed',
    left: sidebarOpen ? '206px' : '20px',
    top: '6px',
    zIndex: 1000,
    transition: 'all 0.3s ease',
    background: '#fff',
    border: '0px solid #ddd',
    borderRadius: '50%',
    width: '33px',
    height: '33px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer'
  }}
>
  {isMobile ? (sidebarOpen ? '✕' : '☰') : (sidebarOpen ? '✕' : '☰')}
</div>




</ToolTipBarra>
       
       <div className={`sidebar ${!sidebarOpen && 'closed'}`}>
       
       <div className="button-group">
       <ButtonGroup
        handleNewChat={handleNewChat}
        handleCopy={handleCopy}
        showCopyIcon={showCopyIcon}
        username={username}
        idUserlink={idUserlink}
      />
        
       </div>
     
       <div className="history-section">
         <p>Historial</p>
         <FilteredPosts selectedPostId={postId} user={user.sub} idUserlink={idUserlink}  />
       </div>
     </div>
 
  </div>
  )}
      {/* Input chat */}
      {isAuthenticated && (    
     <div className={`input-container-text ${!sidebarOpen && 'expanded'}`}>
         <InputComponent messageInput={messageInput} setMessageInput={setMessageInput} handleKeyDown={handleKeyDown} sendMessage={sendMessage2} isStreaming={isStreaming} selectedModel={selectedModel} setSelectedModel={setSelectedModel} selectedUser={selectedUser}/>
     </div>
    )}
      <div className={`main ${!sidebarOpen && 'expanded'}`}>
       
        <div className="disclaimer-base-container">
        <p>Copilot Nawi-GPT ™ 2025 | by Neuraldinamica LLC</p>
        <a className='button-link2' href="#" onClick={() => setIsModalOpen(true)}>Términos de uso.</a>
        </div>
      </div>
      {/* Scrolling Button */}
      {isAuthenticated && (
        <>
          {bodymessagesEndRef.current && !isScrolledToBottom && (
            <div className={`scroll-to-bottom ${!sidebarOpen && 'expanded'}`} onClick={manualScrollToBottom}> 
              <FaArrowDown />
            </div>
          )}
        </>
      )}
      <div className="disclaimer-base-container-terminos">
      
        <Terminos isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
        <Suscripciones isOpen={isSuscripcionesOpen} onClose={() => setSuscripcionesOpen(false)} />
      </div>
    </div>
  );
};

export default Chat;

